import Reveal from '@/components/base/Reveal';
import { scheduleItems } from '@/mocks/site';

export default function Schedule() {
  return (
    <section id="schedule" className="border-t border-background-200/60 bg-background-50 px-5 py-16 pr-14 md:px-10 md:py-24 md:pr-20">
      <div className="mx-auto max-w-6xl">
        <Reveal variant="up" className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-3">
              <span className="h-px w-8 bg-primary-500" />
              <p className="text-[10px] en-label text-primary-600">SCHEDULE</p>
            </div>
            <h2 className="mt-4 font-heading text-[26px] font-black leading-tight text-foreground-950 md:text-[36px]">
              開催情報
            </h2>
            <p className="mt-2 font-heading text-[13px] font-bold text-foreground-500">トライアルフェスタ 開催店舗</p>
          </div>
          <p className="max-w-sm text-[12.5px] leading-[1.9] text-foreground-600">
            熊本県内のトライアル各店舗で順次開催します。入場料は無料です。開催日は現在調整中で、決定次第こちらでお知らせします。
          </p>
        </Reveal>

        <div className="mt-9 border-t border-foreground-200 md:mt-12">
          {scheduleItems.map((item, index) => (
            <Reveal key={item.id} variant="up" delay={index * 100}>
              <article className="grid gap-4 border-b border-foreground-200 py-7 md:grid-cols-12 md:items-center md:gap-6 md:py-9">
                <div className="flex items-center justify-between md:col-span-2 md:block">
                  <div className="flex items-center gap-2.5 md:flex-col md:items-start md:gap-2">
                    <span className="hidden h-px w-7 bg-primary-500 md:block" />
                    <span className="en-label text-[9.5px] tracking-[0.2em] text-foreground-400">{item.en}</span>
                  </div>
                  <span
                    className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[10.5px] font-bold md:hidden ${
                      item.statusKey === 'open'
                        ? 'bg-secondary-100 text-secondary-800'
                        : 'bg-background-200 text-foreground-500'
                    }`}
                  >
                    <span
                      className={`h-1.5 w-1.5 rounded-full ${
                        item.statusKey === 'open' ? 'bg-secondary-500' : 'bg-foreground-400'
                      }`}
                    />
                    {item.status}
                  </span>
                </div>

                <div className="md:col-span-5">
                  <p className="flex items-center gap-1.5 text-[11.5px] text-foreground-500">
                    <i className="ri-map-pin-2-line text-[13px]" aria-hidden="true" />
                    {item.area}
                  </p>
                  <p className="mt-2 font-heading text-[22px] font-black leading-tight text-foreground-950 md:text-[26px]">
                    {item.date}
                  </p>
                  <p className="mt-1.5 text-[11.5px] text-foreground-500">会場：{item.venue}　/　入場料：{item.admission}</p>
                </div>

                <div className="md:col-span-3">
                  <p className="text-[12px] leading-[1.9] text-foreground-600">{item.note}</p>
                </div>

                <div className="md:col-span-2 md:text-right">
                  <div className="hidden md:mb-3 md:flex md:justify-end">
                    <span
                      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[10.5px] font-bold ${
                        item.statusKey === 'open'
                          ? 'bg-secondary-100 text-secondary-800'
                          : 'bg-background-200 text-foreground-500'
                      }`}
                    >
                      <span
                        className={`h-1.5 w-1.5 rounded-full ${
                          item.statusKey === 'open' ? 'bg-secondary-500' : 'bg-foreground-400'
                        }`}
                      />
                      {item.status}
                    </span>
                  </div>
                  {item.open ? (
                    <a
                      href="#vendor"
                      className="inline-flex cursor-pointer items-center gap-1.5 text-[12px] font-bold text-primary-600 transition-colors duration-300 hover:text-primary-700"
                    >
                      出店を申し込む
                      <i className="ri-arrow-right-line" aria-hidden="true" />
                    </a>
                  ) : (
                    <span className="text-[11.5px] text-foreground-400">募集開始前</span>
                  )}
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal variant="fade" delay={150}>
          <p className="mt-5 text-[11px] leading-relaxed text-foreground-400">
            ※ 入場料は無料です。開催日は調整中のため、確定情報は本ページおよび公式SNSにて発表します。会場により仕様は異なります。
          </p>
        </Reveal>
      </div>
    </section>
  );
}